import { useState } from 'react';
import { useQuery } from 'react-query';
import { patientUrls, whoIam } from 'utils/apiUrls';
import { useHttp } from 'hooks/use-fetch';
import { fetchWhoIamCategories } from 'pages/Dashboard/services/whoiam.services';
import { CategoryType } from 'pages/Dashboard/types/whoiam.types';
import { fetchPatientList } from 'pages/Dashboard/services/patient.services';

export type PatientNames = {
  [key: string]: {
    name: string;
    id: string;
    dob: string;
    providerId: string;
    lastName: string;
  };
};

export type ProviderNames = {
  [key: string]: {
    id: string;
    name: string;
    lastName: string;
  };
};

export default function usePatientProviderMap(queryKey?: string, filterProviderId?:string) {
  const { http, providerId } = useHttp();

  const [firstPatientId, setFirstPatientId] = useState<string | undefined>(undefined);
  const [scaleNames, setScaleNames] = useState<Record<string, string>>(
    {} as Record<string, string>,
  );
  const {
    isFetching: isFetchingPatientsList,
    isError: isErrorPatientsList,
    refetch: refetchPatientsList,
  } = useQuery(
    [patientUrls.listPatients.queryUrl,
      providerId,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      1],
    {
      queryFn: fetchPatientList(http.get, true),
      enabled:
        !!providerId,
      refetchOnMount: 'always',
      onSuccess({ patients }) {
        if (patients && patients.length > 0) {
          setFirstPatientId(patients[0]?.id);
        }
      },
    },
  );

  const {
    isFetching: isFetchingCategories,
    isError: isCategoriesError,
    refetch: refetchCategories,
  } = useQuery([whoIam.categories.queryUrl, providerId, firstPatientId], {
    queryFn: fetchWhoIamCategories(http.get),
    onSuccess: ({ categories }) => {
      const scales = categories.reduce((acc, category) => {
        category.type === CategoryType.WIM_CATEGORY_TYPE_RATING_SCALE
          && (acc[category.id] = category.abbreviation);
        return acc;
      }, {} as Record<string, string>);
      setScaleNames(scales);
    },
    enabled: !!providerId && !!firstPatientId,
  });

  return {
    isFetching: isFetchingCategories || isFetchingPatientsList,
    isError: isCategoriesError || isErrorPatientsList,
    scaleNames,
    refetchPatientsList,
    refetchCategories,
  };
}
